export default (props = {}) => <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="tips/check_success">
<path id="Subtract" fill-rule="evenodd" clip-rule="evenodd" d="M16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3ZM13.998 18.3779L9.86719 14.9355L7.94727 17.2402L13.998 22.2842L25.3535 12.8223L23.4336 10.5176L13.998 18.3779Z"/>
</g>
</svg>
